(function($) {
    let validator = null;
    let mainframePort = null;
    let stopPort = null;
    let parallelPort = null;
    let derbyPort = null;
    let internalProxyPort = null;
    let faMessagingPort = null;
    let tjpMainframePort = null;
    let iStrobeSmf = null;
    let protocolsTemplate = {};
    let showProtocols = false;
    let selectedProtocols = null;
    
    let enableApplyButton = function() {
	    if (validator.form()) {
	    	$('#applyPorts').removeAttr('disabled');
	    	$.clearStatus();
		} else {
		    $('#applyPorts').attr('disabled', 'disabled');
		}
    };
    
    let restart = function() {
    	$.restart({
    		"pingTimeout" : null, 
	    	"restartTimeout" : restartTimeoutText,
	    	"restartingText" : restartingText,
	    	"restartFailed" : restartFailed,
	    	"restartDone" : restartDone
    	});
    };

    let applySettings = function() {
        $.displayLoadingIndicator(savingText, '.form-contents');
        
        let dataToSend = {
            mainframeCommunication : $('#mainframe').val(),
    		applicationStop : $('#stop').val(),
    		parallelProcessing : $('#parallel').val(),
    		derby : $('#derby').val(),
    		internalProxy  : $("#internalProxy").val(),
    		faMessaging : $('#faMessaging').val(),
    		tjpCommunication : $('#tjpMainframe').val(),
    		iStrobeSmf : $('#iStrobeSmf').val()
        };
        
        if (showProtocols) {
        	dataToSend.selectedProtocols = [];
            let $theProtocols = $('#protocols-container .switch-input:checked');
            
            for (let index = 0; index < $theProtocols.length; index++) {
            	dataToSend.selectedProtocols.push($($theProtocols[index]).attr('data-name'));
            }
        }
        
        $.when(
            $.ajax({
                type: 'POST',
                url : '/compuware/ws/Config/ports',
                contentType : 'application/json',
                dataType : 'json',
                data : JSON.stringify(dataToSend),
                cache : false
            })
        ).done(function(response) {
        	$.debugLog("Response from applySettings:");
        	$.debugLog(response);
            restart();
        }).fail(function(xhr, status, error) {
            if (!!xhr && !!xhr.responseJSON) {
                let response = xhr.responseJSON.booleanResponse;
                
                if (Number.isInteger(parseInt(response.message))){
                    $.showErrorStatus(portXNotAvailable.replace('%%', response.message));

                    $('#portSettingsForm').find('input').each(function(index, element){
                    	$element = $(element);
                    	if ($element.val() == response.message){
                        	$element.addClass('error');
                        	$element.addClass('errorborder');	
                        	return false;
                    	}
                    });
                    
                } else {
                    $.showErrorStatus(response.message);
                }
            }
        }).always(function() {
            $.removeLoadingIndicator();
        });
    };
    
    let showRestartDialog = function() {
        $('#restartDialog').dialog({
            title: restartTitle,
            width: 500,
            modal: true,
            draggable : false,
            resizable : false,
            buttons : {
                "OK" : {
                    text : okButtonText,
                    'class' : 'ok-button',
                    click : function() {
                        $.animateCloseDialog('#restartDialog', '#applyPorts');
                        applySettings();
                        $(this).dialog('close');
                    }
                },
                "Cancel" : {
                    text : cancelButtonText,
                    click : function() {
                        $.animateCloseDialog('#restartDialog', '#applyPorts');
                        $(this).dialog('close');
                    }
                }
            },
            open: function(event, ui) {
                $(this).dialog('option', 'position', {my: 'center', at: 'center', of: window});
                $.animateOpenDialog('#restartDialog', '#applyPorts');
            }
        });
    };
    
    let applyHandler = function() {
        $('.initial').removeClass('initial');
        $('.error').removeClass('error');
        $('.errorborder').removeClass('errorborder');
        $.clearStatus();
        let isValid = validator.form();
        $.debugLog("form is valid: " + isValid);
        if (isValid) {
            showRestartDialog();
        } else {
            validator.invalidElements()[0].focus();
        }
    };
    
    let resetHandler = function() {
    	$.clearStatus();
    	$('input').removeClass('error').removeClass('errorborder');
    	$('#mainframe').val(mainframePort);
    	$('#stop').val(stopPort);
    	$('#parallel').val(parallelPort);
    	$('#derby').val(derbyPort);
    	$('#internalProxy').val(internalProxyPort);
    	$('#faMessaging').val(faMessagingPort);
    	$('#tjpMainframe').val(tjpMainframePort);
    	$('#iStrobeSmf').val(iStrobeSmf);
    	setSelectedProtocols(selectedProtocols);
    }
    
    let initialize = function(ports) {
        if (!!ports) {
        	ports = ports.portConfiguration;
        	mainframePort = ports.mainframeCommunication;
        	stopPort = ports.applicationStop;
            parallelPort = ports.parallelProcessing;
            derbyPort = ports.derby;
            internalProxyPort = ports.internalProxy;
            faMessagingPort = ports.faMessaging;
            tjpMainframePort = ports.tjpCommunication;
            iStrobeSmf = ports.iStrobeSmf;
            showProtocols = ports.showProtocols;
            
            if (showProtocols) {
            	// Create slider control for each enabled protocol
            	createEnabledProtocols(ports.enabledProtocols);
            	selectedProtocols = ports.selectedProtocols;
            	setSelectedProtocols(selectedProtocols);
            	$('#tlsSupport').show();
            }
            
            resetHandler();
        }
    };
    
    let createEnabledProtocols = function(protocols) {
        $('#protocols-container').append(Mustache.to_html(protocolsTemplate, {protocols: protocols}));
    }

    let setSelectedProtocols = function(protocols) {
        $('#protocols-container .switch-input').prop('checked', false);
        if (!!protocols) {
            if (!$.isArray(protocols)) {
            	protocols = [protocols];
            }
            protocols.forEach(function(protocol) {
                $($.find('#protocols-container .switch-input[data-name="' + protocol + '"]')).prop('checked', true);
            });
        }
    }

    let unique = function(value, index, self){
    	return self.indexOf(value) === index;
    }
    
    let allPortsUnique = function() {
    	let ports = [
			$('#mainframe').val(),
			$('#stop').val(),
			$('#parallel').val(),
			$('#derby').val(),
			$('#internalProxy').val(),
			$('#faMessaging').val(),
			$('#tjpMainframe').val(),
			$('#iStrobeSmf').val()
		];
    	
    	return (ports.length == ports.filter(unique).length);
    }
    
    $(document).ready(function() {
        $.getJSON('registration/listApps', 
        {
        	complete: "yes"
        }).done(function(response) {
            if (response) {
                let applications = response.applications;
    			$.debugLog("Installed applications:");
    			$.debugLog(applications);
                
                if (applications) {
                    
                    for (let index = 0; index < applications.length; index++) {
        				// Possible types: iStrobe, FaultAnalytics, AbendAid, topazjava, ISPW iBrowser
                        let application = applications[index];
                        
        				if (application.app === "FaultAnalytics") {
        					$('#faPorts').show();
        				} else if(application.app === "topazjava") {
        					$('#tjpPorts').show();
        				} else if(application.app === "iStrobe") {
        					$('#iStrobePorts').show();
        				}
                    }
                }
            }
        });
    	
    	$.validator.addMethod("portsUnique", function(value, element) {
    		return allPortsUnique();
        }, portsEqualError);
    	
    	mainframePort = $('#mainframe').val();
    	stopPort = $('#stop').val();
    	parallelPort = $('#parallel').val();
    	derbyPort = $('#derby').val();
    	internalProxyPort = $('#internalProxy').val();
    	faMessagingPort = $('#faMessaging').val();
    	tjpMainframePort = $('#tjpMainframe').val();
    	iStrobeSmf = $('#iStrobeSmf').val();
        protocolsTemplate = $('#protocolsTemplate').html().trim();
    	
        validator = $('#portSettingsForm').validate({
            rules: {
                mainframe: {                     
                    required: true,
                    portsUnique : true,
                    digits : true,
                    min : 1,
                    max : 65535
                },
                stop: {                     
                    required: true,
                    portsUnique : true,
                    digits : true,
                    min : 1,
                    max : 65535
                },
                parallel: {                     
                    required: true,
                    portsUnique : true,
                    digits : true,
                    min : 1,
                    max : 65535
                },
                derby: {                     
                    required: true,
                    portsUnique : true,
                    digits : true,
                    min : 1,
                    max : 65535
                },
                internalProxy: {                     
                    required: true,
                    portsUnique : true,
                    digits : true,
                    min : 1,
                    max : 65535
                },
                faMessaging: {                     
                    required: true,
                    portsUnique : true,
                    digits : true,
                    min : 1,
                    max : 65535
                },
                tjpMainframe: {                     
                    required: true,
                    portsUnique : true,
                    digits : true,
                    min : 1,
                    max : 65535
                },
                iStrobeSmf: {                     
                    required: true,
                    portsUnique : true,
                    digits : true,
                    min : 1,
                    max : 65535
                }
                
            },
            errorPlacement: function (error, element) {
                let $element = $(element);
                $element.removeClass("valid");
                $element.addClass("errorborder");
                $('#portsTab').addClass("error");
                
                let message = error.html();
                
                if (message && message.length > 0) {
                    $.showErrorStatus(message);
                    $('#applyPorts').attr('disabled', 'disabled');
                }
            },
            success : function(success, element) {
                $(element).removeClass('error');
                $(element).removeClass('errorborder');
                
                if (validator.numberOfInvalids() === 0) {
                    $.clearStatus();
                    $('#portsTab').removeClass("error");
                    $('#applyPorts').removeAttr('disabled');
                }
            },
            onfocusin : function(element, event) {
                if (!$(element).hasClass('initial')) {
                    validator.element(element);
                }
                if(!$(element).hasClass('errorborder')){
                	$.clearStatus();
                }
            },
            onfocusout : function(element, event) {
                $(element).removeClass('initial');
                validator.element(element);
            },
            onkeyup : function(element, event) {
                if (event.which !== 9) { // tab key can be ignored because of focus out
                    $(element).removeClass('initial');
                    validator.element(element);
                }
            }
        });
        
        $.when(
            $.ajax({
                type: 'GET',
                url : '/compuware/ws/Config/ports',
                dataType : 'json',
                cache : false
            })
        ).done(function(response) {
        	$.debugLog("Ports read from config:");
        	$.debugLog(response);
            initialize(response);
        }).fail(function() {
        }).always(function() {
            $(window).trigger('portsLoaded');

        });
        
        $('#mainframe, #stop, #parallel, #derby, #internalProxy, #faMessaging, #tjpMainframe, #iStrobeSmf').on('change', enableApplyButton);
        $('#applyPorts').on('click', applyHandler);
        $('#resetPorts').on('click', resetHandler);
		$('.form input').on('click', function(event){
			event.stopPropagation();
		});
    });
})(jQuery);